import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateDefaultDriveMutationVariables = Types.Exact<{
  userPrincipalName: Types.Scalars['String'];
  driveLetter?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type UpdateDefaultDriveMutation = { __typename?: 'MutationModel', employees?: { __typename?: 'EmployeeMutationModel', updateDefaultDrive?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null } | null> | null } | null } | null };


export const UpdateDefaultDriveDocument = gql`
    mutation UpdateDefaultDrive($userPrincipalName: String!, $driveLetter: String) {
  employees {
    updateDefaultDrive(
      userPrincipalName: $userPrincipalName
      driveLetter: $driveLetter
    ) {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type UpdateDefaultDriveMutationFn = Apollo.MutationFunction<UpdateDefaultDriveMutation, UpdateDefaultDriveMutationVariables>;

/**
 * __useUpdateDefaultDriveMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultDriveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultDriveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultDriveMutation, { data, loading, error }] = useUpdateDefaultDriveMutation({
 *   variables: {
 *      userPrincipalName: // value for 'userPrincipalName'
 *      driveLetter: // value for 'driveLetter'
 *   },
 * });
 */
export function useUpdateDefaultDriveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultDriveMutation, UpdateDefaultDriveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultDriveMutation, UpdateDefaultDriveMutationVariables>(UpdateDefaultDriveDocument, options);
      }
export type UpdateDefaultDriveMutationHookResult = ReturnType<typeof useUpdateDefaultDriveMutation>;
export type UpdateDefaultDriveMutationResult = Apollo.MutationResult<UpdateDefaultDriveMutation>;
export type UpdateDefaultDriveMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultDriveMutation, UpdateDefaultDriveMutationVariables>;